var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0H3.5C1.85 0 0.5 1.35 0.5 3V21C0.5 22.65 1.85 24 3.5 24H11V25.5C11 26.325 11.675 27 12.5 27H21.5C22.325 27 23 26.325 23 25.5V24H30.5C32.15 24 33.485 22.65 33.485 21L33.5 3C33.5 1.335 32.15 0 30.5 0ZM29 21H5C4.175 21 3.5 20.325 3.5 19.5V4.5C3.5 3.675 4.175 3 5 3H29C29.825 3 30.5 3.675 30.5 4.5V19.5C30.5 20.325 29.825 21 29 21ZM20.72 13.305L14.75 16.725C13.745 17.295 12.5 16.56 12.5 15.42V8.58C12.5 7.425 13.745 6.705 14.75 7.275L20.72 10.695C21.725 11.28 21.725 12.72 20.72 13.305Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.1309afe3df99608766447c6f799dc9fc.svg";
export { ForwardRef as ReactComponent };